import React from 'react';
import { useCurrentUser } from '../contexts/CurrentUserContext';
import aideyLogo from '../assets/sidebar-logo.svg';

// CASCADE-2 — a CHILD whose account owner has lapsed. NO billing words, no owner
// email, no payment action. Something a child can read.
const NAVY = '#0C2D48';

export default function ChildPaused() {
  const { logout } = useCurrentUser();
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 'var(--z-modal)',
      background: `linear-gradient(150deg, ${NAVY} 0%, #1a4a7a 50%, #0a2038 100%)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1.5rem', fontFamily: 'Raleway, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 18, padding: '2.5rem 2rem',
        maxWidth: 420, width: '100%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
      }}>
        <img src={aideyLogo} alt="Aidey" style={{ height: 40, margin: '0 auto 1.25rem', display: 'block' }} />
        <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>⏸️</div>
        <h2 style={{ fontFamily: 'Poppins, sans-serif', fontSize: '1.4rem', fontWeight: 800, color: NAVY, margin: '0 0 0.75rem' }}>
          Aidey is having a little rest
        </h2>
        <p style={{ color: '#444', fontSize: '1.05rem', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
          Aidey is paused at the moment. Ask a grown up to sort it out and you will get your jobs and stars back.
        </p>
        <button
          onClick={() => logout()}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#bbb', fontSize: '0.82rem', textDecoration: 'underline', fontFamily: 'Raleway, sans-serif',
          }}
        >
          Log out
        </button>
      </div>
    </div>
  );
}
